import { render, staticRenderFns } from "./Clubstables_list.vue?vue&type=template&id=3f507358&scoped=true&"
import script from "./Clubstables_list.vue?vue&type=script&lang=js&"
export * from "./Clubstables_list.vue?vue&type=script&lang=js&"
import style0 from "./Clubstables_list.vue?vue&type=style&index=0&id=3f507358&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f507358",
  null
  
)

export default component.exports